import upstreamMessages from '../../../app/javascript/dashboard/i18n';
import en from '../../overrides/locales/dashboard/en.json';
import fa from '../../overrides/locales/dashboard/fa.json';
import { mergeLocaleMessages } from './mergeMessages';

export const orbexDashboardOverrides = { en, fa };

export default mergeLocaleMessages(upstreamMessages, orbexDashboardOverrides);
